<script>
    import Fa from 'svelte-fa'
    import { faChartLine, faStethoscope, faTachometerAlt, faXRay } from '@fortawesome/free-solid-svg-icons'
    import { Route, Link, Router } from 'yrv'
    import Content from '../_common/content.svelte'
    import DashboardHome from './dashboard-home.svelte'
    import DashboardConversions from './dashboard-conversions.svelte'
    import DashboardReferrals from './dashboard-referrals.svelte'
    import DashboardPayments from './dashboard-payments.svelte'
    import DashboardServices from './dashboard-services.svelte'
    import DashboardProductivity from './dashboard-productivity.svelte'
    // o raio-x antigo (dashboard-xray.svelte) continua no projeto; a interface aponta para o v2
    import DashboardXray from './dashboard-xray-v2.svelte'
    import DashboardPay from './dashboard-pay.svelte'
    import DashboardAgendas from './dashboard-agendas.svelte'
    import DashboardCommunication from './dashboard-communication.svelte'
    import DashboardGeo from './dashboard-geo.svelte'
    import Ztab from '../_common/z/ztab.svelte'

    let tabs = []
    tabs.push({ title: 'Início', url: '/dashboard/home' })
    tabs.push({ title: 'Raio-X', url: '/dashboard/x-ray' })
    tabs.push({ title: 'Agendas', url: '/dashboard/agendas' })
    tabs.push({ title: 'Comunicação', url: '/dashboard/communication' })
    tabs.push({ title: 'Conversões', url: '/dashboard/conversions' })
    tabs.push({ title: 'Origens', url: '/dashboard/referrals' })
    tabs.push({ title: 'Geomarketing', url: '/dashboard/geo' })
    tabs.push({ title: 'Meios de pagamento', url: '/dashboard/payments' })
    tabs.push({ title: 'Serviços', url: '/dashboard/services' })
    tabs.push({ title: 'ZanduPay', url: '/dashboard/zandupay' })
    //tabs.push({ title: 'Comunicação', url: '/dashboard-v2/productivity' })
</script>

<Content>
    <div class="root-content">
        <Ztab class="h-space" {tabs} />
        <div class="p-bottom-sm">
            <Router>
                <Route path="/home">
                    <DashboardHome />
                </Route>
                <Route path="/x-ray">
                    <DashboardXray></DashboardXray>
                </Route>
                <Route path="/conversions">
                    <DashboardConversions />
                </Route>
                <Route path="/referrals">
                    <DashboardReferrals />
                </Route>
                <Route path="/geo">
                    <DashboardGeo />
                </Route>
                <Route path="/payments">
                    <DashboardPayments />
                </Route>
                <Route path="/services">
                    <DashboardServices />
                </Route>
                <Route path="/productivity">
                    <DashboardProductivity />
                </Route>
                <Route path="/zandupay">
                    <DashboardPay />
                </Route>
                <Route path="/agendas">
                    <DashboardAgendas />
                </Route>
                <Route path="/communication">
                    <DashboardCommunication />
                </Route>
            </Router>
        </div>
    </div>
</Content>
